import webSocket from './webSocket'
import { sendLogin, sendReady, sendChat, sendRead, getHistory, sendTakeOverUser, sendRecallMessage, sendSetTop, sendOnTyping, sendAddTalk } from './action'
import emitter from './emitter'
import { getCache, loading, tip } from './utils'
import TYPE from './emitType'
import dayjs from 'dayjs'
import { pick, debounce, sortBy } from 'lodash-es'
import 'intersection-observer'
import { getCsQuickReply, getCsUserInfo, updateUserinfo } from './customerService'
import tippy from 'tippy.js'
import Clipboard from 'clipboard'
import axios from 'axios'
import qs from 'qs'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import userAvatarFallback from '@/assets/customer-service/user.png'

export default {
  install: app => {
    app.use(['layer', 'layim', 'jquery', 'util'], (layer, layim, $, util) => {
      const { send, socket } = webSocket.install(app)
      let takeOverQueue = []
      // 账号在别处登录(err=3)后不再重连/重试登录
      let stopLoginRetry = false

      // socket 连接成功
      emitter.on(TYPE.SOCKET_OPEN, e => {
        if (stopLoginRetry) return
        loading.open('Logging in ...')
        // 请求登录
        send(sendLogin())
      })

      // socket 重新连接
      emitter.on(TYPE.SOCKET_RECONNECT, e => {
        loading.open('Reconnecting ...')
      })

      // socket 连接失败
      emitter.on(TYPE.SOCKET_ERROR, () => {
        // layer.open({
        //   title: 'tip',
        //   content: `socket is error`,
        //   btn: 'Login again',
        //   yes(i) {
        //     location.reload()
        //   }
        // })
      })

      // socket 关闭
      emitter.on(TYPE.SOCKET_CLOSE, () => {
        // layer.open({
        //   title: 'tip',
        //   content: `socket is close`,
        //   btn: 'Login again',
        //   yes(i) {
        //     location.reload()
        //   }
        // })
      })

      // 登录成功
      emitter.on(TYPE.LOGIN_SUCCESS, () => {
        // 发送准备完毕得到 会话列表 和 接管列表
        send(sendReady())
      })

      // 登录失败
      emitter.on(TYPE.LOGIN_FAIL, ({ msg, code }) => {
        if (code === 3) {
          // Your account is logged in another place — 停止 Sockette 自动重连与登录重试
          stopLoginRetry = true
          socket?.close()
        } else {
          // 其它失败仍关闭底层 ws，允许 Sockette 按策略重连
          socket?.ws?.close()
        }
        loading.close()
        layer.msg(msg, { icon: 2 })
        // layer.open({
        //   title: 'tip',
        //   content: `${msg}`,
        //   btn: 'Login again',
        //   yes(i) {
        //     location.reload()
        //   }
        // })
      })

      // 准备基础信息成功
      emitter.on(TYPE.READY_SUCCESS, () => {
        loading.close()
        initIm()
      })

      // 准备基础信息失败
      emitter.on(TYPE.READY_FAIL, ({ msg, code }) => {
        tip(`${msg}: ${code}`)
      })

      // 对话列表
      emitter.on(TYPE.GET_TALK_LIST, data => {
        setFriendList({ groupid: 1, ...data })
      })

      // 接管列表
      emitter.on(TYPE.GET_TAKE_OVER_LIST, ({ list, ...data }) => {
        setFriendList({ groupid: 2, list: list.map(v => Object.assign({ event: 'takeOver' }, v)), ...data })
      })

      // 获取历史消息
      emitter.on(TYPE.GET_HISTORY_SUCCESS, ({ list, userInfo }) => {
        const dom = document.getElementById(`chat-${userInfo.id}`)
        const ul = dom.querySelector('.layim-chat-main ul')
        const { mine: mineInfo } = getCache()
        if (!dom.dataset.loadHistory) {
          if (list.length) {
            const historyHtml = list.map(item => {
              return `
            <li id="${item.messageId}" data-read="${item.state}" data-mine="${Number(item.mine)}" ${item.mine ? 'class="layim-chat-mine"' : ''}>
                <div class="layim-chat-user">
                    <div class="layim-chat-avatar">
                        <img src="${item.mine ? mineInfo.avatar : userInfo.avatar}" />
                    </div>
                    <cite>
                        ${!item.mine ? userInfo.nick : ''}
                        <i>${dayjs(item.timestamp).format('DD/MM/YYYY HH:mm')}</i>
                        ${item.mine ? mineInfo.nick : ''}
                    </cite>
                </div>
                <div class="layim-chat-text ${/.*img\[.+\].*/.test(item.content) ? 'layim-chat-img' : ''}">${layim.content(item.content)}<span class="copy" data-clipboard-text="${item.content}">Copy</span></div>
            </li>
          `
            }).join('')
            ul.insertAdjacentHTML('afterbegin', historyHtml)
            resetScroll(userInfo)
            list.forEach(item => readMessage.observe(item.messageId))
          }
          // 标记为已加载历史消息
          dom.dataset.loadHistory = '1'
        }
        console.log('历史消息', list)
      })

      // 使用LayIM内置复制功能
      document.addEventListener('click', (e) => {
        const target = e.target
        if (target.classList.contains('copy')) {
          const text = target.dataset.clipboardText
          if (!text) return

          util.copy(text)
          layer.msg('Copied');
        }
      })

      // 自己或者对方发送的消息
      emitter.on(TYPE.CHAT, res => {
        const friend = getFriend(res.sendId)
        const data = Object.assign(res, pick(friend, ['avatar', 'username', 'nick']))
        layim.getMessage(data)
        resetScroll(res)
        readMessage.observe(res.messageId)
        // 浏览器通知
        if (getCache().mine.id !== data.sendId) {
          layim.notice({
            title: `Message from ${data.username}`,
            content: data.content,
            avatar: data.avatar || userAvatarFallback
          })
        }
        // 更新最后对话时间
        const target = getCache().mine.id !== data.sendId ? friend : getFriend(res.id)
        if (target) {
          const lastSendTime = Math.floor(new Date().getTime() / 1000)
          const lastSendTimeStr = lastSendTime ? dayjs().format('HH:mm') : ''
          Object.assign(target, { lastSendTime, lastSendTimeStr })
          sortList()
        }
      })

      // 发送失败
      emitter.on(TYPE.SEND_FAIL, ({ msg, code }) => {
        tip(`${msg}: ${code}`)
      })

      // 设置未读消息数量
      emitter.on(TYPE.UNREAD_NUM, ({ list }) => {
        updateUnreadNum(list)
      })

      // 接管用户成功
      emitter.on(TYPE.GET_TAKE_OVER_SUCCESS, ({ userId }) => {
        // layer.confirm('Open chat?', { icon: 1, title: 'Take Over Success', btn: ['Open', 'cancel'] }, (index) => {
        //   openChat(userId)
        //   layer.close(index)
        // })
        layer.msg('Take Over Success', { icon: 1, time: 1000 })
        // 添加进队列, 此时好友列表还未更新
        takeOverQueue.push(userId)
      })

      // 接管用户失败
      emitter.on(TYPE.GET_TAKE_OVER_FAIL, ({ msg, code }) => {
        tip(`${msg}: ${code}`)
        loading.close()
      })

      // 已读消息成功
      emitter.on(TYPE.READ_MESSAGE_SUCCESS, ({ messageId }) => {
        const target = document.getElementById(messageId)
        // 我的消息设置为已读
        if (target && target.dataset.mine === '1') {
          target.dataset.read = '1'
        }
      })

      // 已读消息失败
      emitter.on(TYPE.READ_MESSAGE_FAIL, ({ msg }) => {
        console.warn(`read message fail: ${msg}`)
      })

      // 撤回消息成功
      emitter.on(TYPE.RECALL_MESSAGE_SUCCESS, ({ messageId }) => {
        const dom = document.getElementById(messageId)
        if (dom) {
          readMessage.unobserve(messageId)
          dom.remove()
        }
        layer.msg('Recall message success', { icon: 1, time: 1500 })
      })

      // 撤回消息失败
      emitter.on(TYPE.RECALL_MESSAGE_FAIL, ({ msg }) => {
        tip(msg)
      })

      // 设置/取消置顶成功
      emitter.on(TYPE.SET_TOP_SUCCESS, ({ type, userId }) => {
        layer.msg(`${type ? 'Set' : 'Cancel'} top success`, { icon: 1, time: 1500 })
        const { friend } = getCache()
        const list = friend[0].list
        const item = list.find(v => v.id === userId)
        item.isTop = type
        sortList()
      })

      // 设置/取消置顶失败
      emitter.on(TYPE.SET_TOP_FAIL, ({ msg }) => {
        tip(msg)
      })

      // 正在输入成功
      emitter.on(TYPE.TYPING_SUCCESS, ({ userId }) => {
        //layer.msg(`${userId} ontyping success`, { icon: 1, time: 1500 })
        layim.setChatStatus('<span style="color:black;">正在输入...</span>'); //模拟标注好友在线状态
        var tid = layim.cache().typing_tid ?? 0;
        if (tid != 0) clearTimeout(tid);
        var new_tid = setTimeout(function () {
          layim.setChatStatus('');
        }, 1000);
        layim.cache().typing_tid = new_tid;
      })

      // 正在输入失败
      emitter.on(TYPE.TYPING_FAIL, ({ msg }) => {
        tip(msg)
      })

      // 监听发送的消息
      layim.on('sendMessage', res => {
        send(sendChat(res))
      })

      const onChatChange = debounce(function (res) {
        const { id } = res.data
        const dom = res.elem[0]
        // 设置唯一 id
        if (!dom.id) {
          dom.id = `chat-${id}`
        }
        const data = getFriend(id)
        // 没有加载过历史消息就获取历史消息
        if (!dom.dataset.loadHistory) {
          // 获取历史消息
          send(getHistory(id))
        }
        if (data) {
          // 更新在线状态
          layim.setFriendStatus(id, data.status)
          // 更新未读数字
          setFriendUnread(id, data.unread)
        }
        // 存储会话 id
        storageChat.set()
      }, 200)

      // 监听每次窗口打开或切换
      layim.on('chatChange', onChatChange)

      // 监听点击接管用户
      layim.on('takeOver', ({ id }) => {
        send(sendTakeOverUser(id))
        loading.open('Loading...')
        // layer.confirm('Confirm take over user?',
        //   { icon: 3, title: 'tip', btn: ['confirm', 'cancel'] },
        //   index => {
        //     send(sendTakeOverUser(id))
        //     layer.close(index)
        //     loading.open('Loading...')
        //   }
        // )
      })

      // 监听工具栏快捷回复
      layim.on('tool(quickReply)', () => {
        quickReply()
      })

      layim.on('tool(userInfo)', () => {
        userInfo()
      })

      initCopy()

      const contextMenu = initMessageContextMenu()

      // 监听撤回消息
      layim.on('recallMessage', target => {
        const id = target[0].parentNode.dataset.id
        send(sendRecallMessage(id))
        contextMenu.hide()
      })

      // 设置/取消置顶
      layim.on('setTop', target => {
        const id = Number(target[0].parentNode.dataset.id)
        const isTop = Number(target[0].dataset.isTop)
        send(sendSetTop(id, 1 ^ isTop))
      })

      // 关闭对话窗口
      layim.on('closeChat', () => {
        // 存储会话 id
        storageChat.set()
      })

      // 监听点击图片
      layim.on('photos', target => {
        const photos = target.parents('.layim-chat-main').find('.layui-layim-photos')
        const photosElement = photos.toArray()
        const pswpElement = document.getElementById('pswp')
        const items = photosElement.map(item => {
          const { src, dataset: { size } } = item
          const [w, h] = size.split('x')
          return {
            src,
            w,
            h
          }
        })
        const options = {
          index: photosElement.indexOf(target[0]),
          history: false
        }
        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
        gallery.init()
      })

      // 添加好友
      layim.on('add', target => {
        layer.prompt({ formType: 0, title: 'Add talk', btn: ['confirm', 'cancel'] }, (val, index, elem) => {
          const value = isNaN(val) ? 0 : Number(val)
          if (!openChat(value)) {
            send(sendAddTalk(value))
            loading.open('Loading...')
          }
          layer.close(index)
        })
      })

      // 添加好友成功
      emitter.on(TYPE.ADD_TALK_SUCCESS, ({ userId }) => {
        console.log('ADD_TALK_SUCCESS', userId)
        layer.confirm('Open chat?', { icon: 1, title: 'Add Success', btn: ['Open', 'cancel'] }, (index) => {
          openChat(userId)
          layer.close(index)
        })
      })

      // 添加好友失败
      emitter.on(TYPE.ADD_TALK_FAIL, ({ msg, code }) => {
        tip(`${msg}: ${code}`)
        loading.close()
      })

      function getToken() {
        let arr = document.cookie.split(';')
        if (arr.length) {
          const name = 'Admin-Token='
          arr = arr.map(function (v) {
            return v.trim()
          })
          const tokenCookie = arr.find(function (v) {
            return v.indexOf(name) > -1
          })
          return tokenCookie.substring(name.length)
        }
        return ''
      }

      function initIm() {
        // 初始化 im
        layim.config({
          title: layim.cache().mine.username,
          // 简约模式
          // brief: true,
          // 设定消息提醒的声音
          voice: false,
          // 开启桌面消息提醒
          notice: false,
          // 可允许的消息最大字符长度
          maxLength: 512,
          init: {
            // 设置我的基础信息
            mine: layim.cache().mine,
            // 好友列表数据
            friend: [{
              groupname: 'Talk List', // 会话列表
              id: 1,
              list: []
            }, {
              groupname: 'Take Over', // 接管列表
              id: 2,
              list: []
            }]
          },
          // 上传图片接口
          uploadImage: {
            // 接口地址
            url: getCache().uploadImageUrl,
            data: {

            }
          },
          // 上传文件接口
          uploadFile: {
            // 接口地址
            url: getCache().uploadImageUrl,
            size: 1024 * 20,
            data: {

            }
          },
          // 配置快捷回复
          tool: [{
            alias: 'quickReply',
            title: 'Quick Reply',
            icon: '&#xe606;'
          }, {
            alias: 'userInfo',
            title: 'User Other Info',
            icon: '&#xe63c;'
          }],
          add: true
        })
      }

      // 聊天消息右键菜单
      function initMessageContextMenu() {
        const instance = tippy(document.body, {
          content: `<div class="layui-layim-contextmenu" style="margin: 0">
                        <div class="layui-layer-content">
                            <ul id="messageContextMenu" data-id>
                                <li layim-event="recallMessage">Recall message</li>
                            </ul>
                        </div>
                    </div>`,
          appendTo: document.body,
          placement: 'right-start',
          allowHTML: true,
          trigger: 'manual',
          interactive: true,
          arrow: false,
          offset: [0, 0],
          zIndex: 19999999
        })
        document.addEventListener('contextmenu', event => {
          let target = event.target
          if (target.classList.contains('layui-layim-photos')) {
            target = target.parentNode
          }
          if (target.classList.contains('layim-chat-text')) {
            const parentNode = target.parentNode
            if (parentNode && target.parentNode.classList.contains('layim-chat-mine')) {
              event.preventDefault()
              instance.setProps({
                getReferenceClientRect: () => ({
                  width: 0,
                  height: 0,
                  top: event.clientY,
                  bottom: event.clientY,
                  left: event.clientX,
                  right: event.clientX
                })
              })
              instance.show()
              setTimeout(() => {
                document.getElementById('messageContextMenu').dataset.id = parentNode.id
              }, 0)
            }
          }
        })
        return instance
      }

      function initCopy() {
        const clipboard = new Clipboard('.copy')
        clipboard.on('success', () => {
          layer.msg('Copy successfully', { icon: 1, time: 1500 })
        })
        clipboard.on('error', () => {
          layer.msg('Copy failed', { icon: 2 })
        })
        return clipboard
      }

      function setFriendList({ type, groupid, list, isStart, isEnd }) {
        console.log('好友列表', 'type', type, 'groupid', groupid, 'list', list)
        const { friend } = getCache()
        const group = friend.find(v => v.id === groupid)
        // 0 更新全部 1 新加 2 删除 3 更新某个人信息
        if (type === 0 && isStart) {
          group.list = []
        }
        if (type === 0 || type === 1) {
          group.list = group.list.concat(list)
        }
        if (type === 2) {
          list.forEach(v => {
            group.list.splice(group.list.findIndex(item => item.id === v.id), 1)
          })
        }
        if (type === 3) {
          list.forEach(v => {
            const data = group.list.find(item => v.id === item.id)
            if (data) {
              Object.assign(data, v)
              // 更新在线状态
              layim.setFriendStatus(v.id, v.status)
            } else {
              group.list = group.list.concat(v)
            }
          })
        }
        if (isEnd) {
          sortList(() => {
            // 列表更新完后, 打开接管对话
            if (takeOverQueue.length) {
              if (type == 1 && groupid == 1) {
                openChat(takeOverQueue)
              }
              takeOverQueue = []
            }
            if (type == 0)
              openPrevChat()
          })
          loading.close()
        }
      }

      const sortList = debounce(function (callback) {
        const { friend } = getCache()
        friend.forEach(group => {
          group.list = sortBy(group.list, ['isTop', 'lastSendTime', 'unread']).reverse()
          layim.updateList(group.list)
        })
        callback && callback()
      }, 500)

      const getFriend = (id) => {
        const { mine } = getCache()
        if (mine.id === id) {
          return mine
        }
        return getAllFriend().find(v => v.id === id)
      }

      const getAllFriend = () => {
        const { friend } = getCache()
        return friend.reduce((result, item) => result.concat(item.list), [])
      }

      const setFriendUnread = (id, unread) => {
        const domList = document.querySelectorAll(`.layim-friend${id}`)
        if (domList) {
          domList.forEach(v => {
            v.dataset.unread = unread
          })
        }
      }

      // 更新未读数量
      const updateUnreadNum = (list) => {
        list.forEach((item) => {
          const { userId, unread } = item
          // 更新 cache
          const data = getFriend(userId)
          if (data) {
            Object.assign(data, item)
            setFriendUnread(userId, unread)
            sortList()
          }
        })
      }

      const readMessage = (() => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(({ target, intersectionRatio }) => {
            const { id } = target
            // 是否显示三分之一
            if (intersectionRatio >= 0.3) {
              // 没有发送已读
              if (target.dataset.read === '0') {
                // 图片消息显示三分之一, 文字消息全部显示
                if (target.querySelector('.layim-chat-img') || intersectionRatio === 1) {
                  send(sendRead(id))
                  target.dataset.read = '1'
                  observer.unobserve(target)
                }
              } else {
                observer.unobserve(target)
              }
            }
          })
        }, { threshold: [0.3, 1] }) // dom 显示三分之一到全部显示
        const observe = (id) => {
          const target = document.getElementById(id)
          if (target) {
            const { mine, read } = target.dataset
            // 不是我的消息, 未读
            if (mine === '0' && read === '0') {
              // 观察 dom 是否可见
              observer.observe(target)
            }
          }
        }
        const unobserve = (id) => {
          const target = document.getElementById(id)
          if (target) {
            observer.unobserve(target)
          }
        }
        return {
          observe,
          unobserve
        }
      })()

      const quickReply = (() => {
        const sendTypeMap = {
          image: 'img[content]',
          link: 'a(content)[content]',
          js: 'js("content")[content]'
        }
        $(document).on('click', '.rightbox-send', event => {
          const { content, type } = event.target.parentNode.dataset
          const id = Number($('#chatList').find('li.layim-this').attr('data-id'))
          const sendType = sendTypeMap[type]
          const formatContent = sendType ? sendType.replace(/content/g, content) : content
          send(sendChat({ mine: { content: formatContent }, to: { id } }))
        })
        $(document).on('click', '.rightbox-toggle', function () {
          const item = $(this).parent().parent()
          item.toggleClass('expand')
          item.siblings().removeClass('expand')
        })
        return () => {
          const chat = document.querySelector('.layui-layim-chat')
          const rightbox = document.getElementById('rightbox-tab-1')
          const state = rightbox.style.display === 'block'
          const hasFull = chat.querySelector('.layui-layer-max').classList.contains('layui-layer-maxmin')
          if (!hasFull) {
            chat.style.width = (parseInt(chat.style.width, 10) + 400 * (state ? -1 : 1)) + 'px'
          }
          rightbox.style.display = state ? 'none' : 'block'
          if (!state) {
            getCsQuickReply()
              .then(res => {
                const data = res?.data?.group ?? []
                if (Array.isArray(data)) {
                  window.layui.use(['laytpl', 'element'], (laytpl, element) => {
                    laytpl(`<div class="layui-collapse" lay-accordion>
                                {{# layui.each(d.data, function(gKey, gItem){ }}
                                    <div class="layui-colla-item">
                                      <h2 class="layui-colla-title">{{ gItem.title }}</h2>
                                      <div class="layui-colla-content">
                                          {{# layui.each(gItem.list, function(lKey, lItem){ }}
                                              <div class="rightbox-item">
                                                <div class="rightbox-title">
                                                  <p class="rightbox-subtitle" data-content="{{ lItem.content }}" data-type="{{ lItem.type }}">{{ lItem.subtitle }} <span class="rightbox-send">Send</span></p>
                                                  <span class="rightbox-toggle"></span>
                                                </div>
                                                <div class="rightbox-content">{{ lItem.type === 'image' ? ('<img src="'+ lItem.content +'" />') : lItem.content }}</div>
                                              </div>
                                          {{#  }); }}
                                      </div>
                                    </div>
                                {{#  }); }}
                            </div>`)
                      .render({ data }, str => {
                        rightbox.innerHTML = str
                      })
                    element.render()
                  })
                }
              })
          } else {
            rightbox.innerHTML = ''
          }
        }
      })()

      const userInfo = (() => {
        $(document).on('click', '.userInfo-toggle', function () {
          const item = $(this).parent().parent()
          item.toggleClass('expand')
          item.siblings().removeClass('expand')
        })
        return () => {
          const chat = document.querySelector('.layui-layim-chat')
          const rightbox = document.getElementById('rightbox-tab-2')
          const state = rightbox.style.display === 'block'
          const hasFull = chat.querySelector('.layui-layer-max').classList.contains('layui-layer-maxmin')
          if (!hasFull) {
            chat.style.width = (parseInt(chat.style.width, 10) + 400 * (state ? -1 : 1)) + 'px'
          }
          rightbox.style.display = state ? 'none' : 'block'
          if (!state) {
            const userid = layim.cache().chattouid;
            // -------------------基本信息---------------------
            getCsUserInfo({ userid: userid })
              .then(res => {
                const data = res?.data?.userinfo ?? []
                if (data) {
                  window.layui.use(['laytpl', 'element', 'form'], (laytpl, element, form) => {
                    laytpl(`<form class="layui-form" action="#" onsubmit="return false;">
                              <div class="layui-form-item">
                                <label class="layui-form-label">标签</label>
                                <div class="layui-input-block">
                                  <input type="hidden" name="userid" required  lay-verify="required" placeholder="请输入ID" autocomplete="off" value="{{ d.data.id }}" class="layui-input">
                                  <input type="text" name="tag" required  lay-verify="required" placeholder="请输入标签" autocomplete="off" value="{{ d.data.tag }}" class="layui-input">
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">备注</label>
                                <div class="layui-input-block">
                                  <textarea id="layui-input-block-userinfo-ext" name="ext" placeholder="请输入内容" class="layui-textarea">{{ d.data.ext }}</textarea>
                                </div>
                              </div>
                              <div class="layui-form-item">
                                <label class="layui-form-label">Tel</label>
                                <div class="layui-input-block">
                                  <input type="text" id="layui-input-block-userinfo-tel" name="tel" required  lay-verify="required" placeholder="请输入Tel" autocomplete="off" value="{{ d.data.tel }}" class="layui-input">
                                </div>
                              </div>
                              <div class="layui-form-item">
                              <div class="layui-input-block">
                                <button class="layui-btn" lay-submit lay-filter="updateUserinfo">更新</button>
                                <button type="reset" class="layui-btn layui-btn-primary">重置</button>
                              </div>
                            </div>
                          </form>`)
                      .render({ data: data, userid: userid }, str => {
                        document.getElementById('userext-tab-1').innerHTML = str
                      })
                    element.render()
                    form.render()

                    //监听提交
                    form.on('submit(updateUserinfo)', function (data) {
                      updateUserinfo(data.field).then(res => {
                        layer.msg(res.msg);
                      })
                      return false;
                    });
                  })
                }
              })
          } else {
            document.getElementById('userext-tab-1').innerHTML = ''
          }
        }
      })()

      function resetScroll({ id }) {
        const chatDom = document.getElementById(`chat-${id}`)
        if (chatDom) {
          const chatMain = chatDom.querySelector('.layim-chat-main')
          if (chatMain) {
            chatMain.scrollTop = chatMain.scrollHeight + 1000
          }
        }
      }

      const storageChat = {
        set: debounce(function () {
          const dom = document.getElementById('chatList')
          if (dom) {
            const chat = Array.from(dom.querySelectorAll('li')).reduce((result, v) => {
              const id = Number(v.dataset.id)
              result.list.push(id)
              if (v.classList.contains('layim-this')) {
                result.current = id
              }
              return result
            }, { list: [], current: 0 })
            localStorage.setItem('chat', JSON.stringify(chat))
          }
        }, 500),
        get() {
          const chat = localStorage.getItem('chat')
          let obj = { list: [], current: 0 }
          try {
            obj = JSON.parse(chat) || obj
            // eslint-disable-next-line no-empty
          } catch (e) { }
          return obj
        },
        clear() {
          localStorage.setItem('chat', JSON.stringify({ list: [], current: 0 }))
        }
      }

      // 打开对话窗口
      const openChat = (id, skipTakeOver) => {
        const ids = [].concat(id).map(v => Number(v))
        let list
        if (skipTakeOver) {
          list = $('#layui-layim .layim-list-friend > li:first-child li')
        } else {
          list = $('#layui-layim .layim-list-friend .layui-layim-list li')
        }
        let flag = false
        list.toArray().forEach(item => {
          if (ids.includes(+item.dataset.id)) {
            item.click()
            flag = true
          }
        })

        $(document).on('keyup', '.layim-chat-textarea', event => {
          const ob_userid = layim.cache().chattouid;
          send(sendOnTyping(ob_userid))
        })

        return flag
      }

      // 页面刷新后打开上次对话
      const openPrevChat = (() => {
        let state = false
        return () => {
          if (!state) {
            state = true
            setTimeout(() => {
              const { list, current } = storageChat.get()
              openChat(list, true)
              openChat(current, true)
            }, 0)
          }
        }
      })()
    })
  }
}
